import { useQueryParam } from '@hooks/useQueryParams';
import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { getFlatsBody } from '@utils/helper/getSearchAndDownloadBodyAllTables';
import { FlatTable } from '@utils/models/FlatTable';
import { HouseSale } from '@utils/models/House';
import { Pagination } from '@utils/models/Pagination';
import { useInfiniteQuery, useQuery } from 'react-query';

import { SearchParamsHome } from '../Home';
import { endPoints } from '../utils/constants/endPoints';
import { queryKeys } from '../utils/constants/queryKeys';
import { FlatFilterParams } from '../utils/models/FlatFilterParams';

export function useSaleFlats(size: number, searchObj: SearchParamsHome) {
  const { searchParams } = useQueryParam<SearchParamsHome, any>();

  return useQuery<Pagination<FlatTable>>(
    [queryKeys.FLAT_LIST, searchObj.page, JSON.stringify(searchObj)],
    async () => {
      const res = await $api.post(endPoints.FLAT_FILTER, {
        ...getFlatsBody(size, searchObj),
        // eslint-disable-next-line no-nested-ternary
        fields: Array.isArray(searchParams?.fields)
          ? searchParams?.fields?.map((item: string) => `${item?.split('_')[0]}:${decodeURI(item?.split('_')[1])}`)
          : searchParams?.fields?.split('_')[0]
            ? [`${searchParams?.fields?.split('_')[0]}:${decodeURI(String(searchParams?.fields?.split('_')[1]))}`]
            : null
      });

      return res?.data?.data;
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchIntervalInBackground: false,
      refetchInterval: 60000,
      onError: baseErrorHandler,
      retry: false
    }
  );
}

export function useFlatTableFilters(props: { enabled?: boolean } = {}) {
  return useQuery<FlatFilterParams>(
    [queryKeys.FLAT_FILTER],
    async () => {
      const res = await $api.get(endPoints.FILTER_PARAMS);

      return res?.data?.data;
    },
    {
      enabled: props?.enabled,
      refetchOnWindowFocus: false,
      refetchInterval: Infinity,
      onError: baseErrorHandler,
      retry: false,
      refetchIntervalInBackground: false,
      refetchOnMount: false,
      refetchOnReconnect: false
    }
  );
}

export function useSaleHousesNew(search?: string) {
  return useInfiniteQuery<Pagination<HouseSale>>(
    [queryKeys.HOUSE_SHOW, search],
    async ({ pageParam = 1 }) => {
      let url = `${endPoints.HOUSE_EXTRA}?page=${pageParam}&size=10`;

      if (search) {
        url += `&name=${search}`;
      }

      const res = await $api.get(url);

      return res?.data?.data;
    },
    {
      refetchOnWindowFocus: false,
      refetchInterval: Infinity,
      onError: baseErrorHandler,
      retry: error => {
        // @ts-expect-error
        if (error?.response?.status === 500) {
          return false;
        }
        return true;
      },
      getNextPageParam: (lastPage, page) => {
        if (page.length < lastPage?.totalPages) {
          return page.length + 1;
        }
        return undefined;
      }
    }
  );
}
